import React, { useEffect, useState } from 'react';
import { reportProps } from './StopLossAggregateTable';
import componentConstants from '../core-utils/messages/componentConstants';
import PptReportTable from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/PptReportTable';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { formatTopPlanPaidTableData } from '../core-utils/helper-utils/quaterlyReportHelper';
import { NoDataTable } from '@HomaHealth/ui-component-library/lib/_AIQ-components';

const cellStyles = {
  width: '50px',
  color: `${patientAccessTheme.palette.text.highemphasis} !important`,
  padding: '5px 10px !important',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '19.8px',
  borderRight: '1px solid white',
  borderBottom: '4px solid white !important',
  backgroundColor: patientAccessTheme.palette.grey[300],

  height: '40px',
};
const headerStyles = {
  color: `${patientAccessTheme.palette.status.white} !important`,
  padding: '5px 10px !important',
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '16px',
  borderRight: '1px solid white',
  borderBottom: '4px solid white !important',
  backgroundColor: patientAccessTheme.palette.grey[700],
  height: '40px',
};
const titleStyles = {
  color: '#2E2F33',
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '22.8px',
  padding: '20px 24px 16px 20px',
  margin: '0 !important',
};

export interface PaidClaimsTrendProps {
  isMedical?: boolean;
}
type CombinedProps = reportProps & PaidClaimsTrendProps;

const TopPlanPaidTable: React.FC<CombinedProps> = ({ data }) => {
  const [planPaidTableData, setPlanPaidTableData] = useState<string[][]>([]);
  const pageConstants = componentConstants.PAGES.CLAIM_METRICS_PAGE;

  const topPlanPaidColumns: any[] = [
    {
      name: 'Category',
    },
    {
      name: 'Plan Impact',
      align: 'left',
      width: '70px',
    },
    {
      name: 'Plan Paid',
      align: 'left',
      width: '40px',
    },
  ];

  useEffect(() => {
    setPlanPaidTableData(formatTopPlanPaidTableData(data?.topPlanPaid));
  }, []);
  return (
    <>
      {planPaidTableData?.length > 0 ? (
        <PptReportTable
          columns={topPlanPaidColumns}
          data={planPaidTableData}
          title={pageConstants.TABLES.TABLE1_TITLE2}
          cellStyles={cellStyles}
          headerStyles={headerStyles}
          titleStyles={titleStyles}
          tableStyles={{
            width: '370px',
            margin: '0.5rem !important',
          }}
          width="400px"
        />
      ) : (
        <NoDataTable
          height={'100%'}
          width={'100%'}
          content={'No Data available'}
        />
      )}
    </>
  );
};
export default TopPlanPaidTable;
